var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-tabs" },
    [
      _c("nav", { staticClass: "v-tabs__header" }, [
        _c(
          "ul",
          { staticClass: "v-tabs__list" },
          _vm._l(_vm.langs, function(lang) {
            return _c(
              "li",
              {
                staticClass: "v-tabs__item",
                class: {
                  "v-tabs__item--is-selected": _vm.selectedLang === lang
                },
                on: {
                  click: function($event) {
                    return _vm.selectLang(lang)
                  }
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "v-tabs__button",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(lang.name) + "\n          "
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.langs, function(lang) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: lang === _vm.selectedLang,
                expression: "lang === selectedLang"
              }
            ],
            staticClass: "v-tabs__body"
          },
          [_vm._t("default", null, { lang: lang })],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d7f640e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7f640e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VTabs.vue
// module id = 318
// module chunks = 1 2